import * as R from 'ramda'
import { call, reducer } from '../../../helpers/api/meta'
import { getCourseReviews } from '../../../helpers/api/api'

export const GET_COURSE_REVIEWS = 'GET_COURSE_REVIEWS'

export const callGetCourseReviews = (inputs) => {
  const meta = {
    endpoint: (params) => getCourseReviews(params),
    inputs,
    action: GET_COURSE_REVIEWS,
    messages: {
      id: 'getCourseReviews',
      failure: 'Could not get course reviews',
    },
  }
  return call(meta)
}

const initialState = {
  loading: false,
  results: [],
}

const saveCourseReviews = (state, action) => {
  return R.assoc('results', action.results, state)
}

const messages = {
  loadFailed: 'Could not load reviews.',
}

export default reducer(initialState, GET_COURSE_REVIEWS, saveCourseReviews, messages.loadFailed)
